// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"751":"04ce4a18","823":"4bac0f1c"}[chunkId] + ".chunk.css";
};